import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class ClaimNotifications extends RestApiModel {
  static getResourceEndpoint() {
    return '/ClaimNotifications';
  }

  static getNotificationDocumentTypes(params) {
    return api.get('/NotificationDocumentTypes', params);
  }

  static getOfflineRaters() {
    return api.get('/GetOfflineClaimNotifciations');
  }

  static getClaimNotification(params) {
    return api.get(`/GetClaimNotificationDocument`, params);
  }

  static getClaimNotificationLink(params) {
    return api.get(`/BuildNotificationLink`, params);
  }
}

export default ClaimNotifications;